import React, { useState } from 'react';
import FormField from './FormField';
import config from '../config';
import './WishForm.css';

function validate(fields) {
  const errors = {};
  if (!fields.name.trim()) errors.name = 'Name is required';
  if (!fields.email.trim()) errors.email = 'Email is required';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) errors.email = 'Enter a valid work email';
  if (!fields.company.trim()) errors.company = 'Company is required';
  if (!fields.problem.trim()) errors.problem = 'Tell us what\'s driving your team crazy';
  return errors;
}

export default function WishForm({ onSuccess, onError }) {
  const [fields, setFields] = useState({ name: '', email: '', company: '', problem: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setFields(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(e => ({ ...e, [name]: '' }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate(fields);
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }

    setLoading(true);
    const payload = { ...fields, user_agent: navigator.userAgent };

    // If WEBHOOK_URL is not configured, simulate success for dev/testing
    if (config.WEBHOOK_URL === 'REPLACE_WITH_YOUR_APPS_SCRIPT_WEB_APP_URL') {
      await new Promise(r => setTimeout(r, 1200)); // simulate network
      setLoading(false);
      onSuccess(fields);
      return;
    }

    try {
      await fetch(config.WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      });
      onSuccess(fields);
    } catch (err) {
      console.error('Submission failed:', err);
      onError();
    } finally {
      setLoading(false);
    }
  }

  return (
    <form className="wish-form" onSubmit={handleSubmit} noValidate>
      <div className="wish-form__fields">
        <FormField
          label="Your name"
          id="name"
          value={fields.name}
          onChange={handleChange}
          placeholder="Sarah Chen"
          required
          autoComplete="name"
          error={errors.name}
        />
        <FormField
          label="Work email"
          id="email"
          type="email"
          value={fields.email}
          onChange={handleChange}
          placeholder="sarah@company.com"
          required
          autoComplete="email"
          error={errors.email}
        />
        <FormField
          label="Company"
          id="company"
          value={fields.company}
          onChange={handleChange}
          placeholder="Acme Corporation"
          required
          autoComplete="organization"
          error={errors.company}
        />
        <FormField
          label="The process driving your team crazy"
          id="problem"
          multiline
          value={fields.problem}
          onChange={handleChange}
          placeholder="e.g. supplier risk re-screening, off-catalog spend approvals, contractor rate true-up…"
          required
          maxLength={500}
          error={errors.problem}
        />
      </div>

      <button
        type="submit"
        className={`wish-form__submit ${loading ? 'wish-form__submit--loading' : ''}`}
        disabled={loading}
      >
        {loading ? (
          <span className="wish-form__spinner-row">
            <span className="wish-form__spinner" />
            Sending your wish…
          </span>
        ) : (
          'Send my wish'
        )}
      </button>

      <p className="wish-form__footnote">
        No demos. No sales asks. Just a custom sketch in your inbox — one week from today.
      </p>
    </form>
  );
}
